module.exports = "/_next/static/images/hr-onboarding-e54f7f77418ba0312e53be136b91f4a7.svg";